import PropTypes from "prop-types"
import React, { Component } from "react"
import { Link } from "react-router-dom"
import BackIcon from "../../images/icons/arrow_left-33.png"

export default class BackNavigator extends Component {
  static propTypes = {
    url: PropTypes.string.isRequired,
  }

  render() {
    return (
      <div className="common-back-navigator">
        <Link to={this.props.url} className="go-back">
          <img className="icon icon-back" alt="Zurück" src={BackIcon} />
        </Link>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/common/BackNavigator.js